import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url =
  process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";

import eventTracker from "../../../utils/analytics";
import EVENT_NAMES from "../../../utils/eventNames";

export const getUserDetailsThunk = createAsyncThunk(
  "get-user-details",
  async ({ token }) => {
    try {
      const response = await axios.get(`${api_Url}/api/profile-details`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateProfileThunk = createAsyncThunk(
  "update-profile",
  async ({ data, token }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(
        `${api_Url}/api/user-profile-detail-update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        eventTracker.track(EVENT_NAMES.PROFILE_UPDATED, {
          userId: state?.auth?.user?.user?.id,
          email: state?.auth?.user?.user?.email,
          data: data,
        });
      }
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getAddressListThunk = createAsyncThunk(
  "get-address-list",
  async ({ token, user_id }) => {
    try {
      const response = await axios.get(`${api_Url}/api/address-list`, {
        params: { user_id },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addAddressThunk = createAsyncThunk(
  "add-address",
  async ({ data, token }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(`${api_Url}/api/add-address`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const address = response?.data?.data;
      eventTracker.track(EVENT_NAMES.ADDRESS_ADDED, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        data: address,
      });

      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const updateAddressThunk = createAsyncThunk(
  "update-address",
  async ({ data, token }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(`${api_Url}/api/update-address`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const address = response?.data?.data;
      eventTracker.track(EVENT_NAMES.ADDRESS_UPDATED, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        data: address,
      });

      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const deleteAddressThunk = createAsyncThunk(
  "delete-address",
  async ({ token, id }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(
        `${api_Url}/api/delete-address`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      eventTracker.track(EVENT_NAMES.ADDRESS_DELETED, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        data: id,
      });

      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const updateLocationThunk = createAsyncThunk(
  "update-location",
  async ({ data, token }) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/updateCurrentLocation`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);
